import { Typography, Box } from '@mui/material';

/**
 * A small version badge displayed at the very bottom of the app,
 * below the bottom action bar. Right-aligned to match original design.
 */
export const VersionBadge: React.FC = () => {
  return (
    <Box
      sx={{
        flexShrink: 0,
        width: '100%',
        textAlign: 'right',
        pr: 1,
        py: 0.25,
        pointerEvents: 'none',
        userSelect: 'none',
      }}
    >
      <Typography
        component="span"
        sx={{
          fontSize: '10px',
          lineHeight: 1,
          opacity: 0.4,
          color: 'text.secondary',
          fontFamily: 'monospace',
          letterSpacing: '0.02em',
        }}
      >
        v{__APP_VERSION__}
      </Typography>
    </Box>
  );
};
